import type { JSX } from 'react';
import { IconValidationInvalid } from '@adc/parallax-icons';

type ErrorLike = string | { message?: string } | undefined;
export type ErrorProps = {
  error: boolean;
  supportingText?: string;
  supportingIconConfig?: { icon: JSX.Element };
};

type FieldLike = {
  state: {
    meta: {
      isTouched: boolean;
      isValid: boolean;
      errors: ErrorLike[];
    };
  };
};

export const getErrorProps = (
  { state: { meta } }: FieldLike,
  defaultSupportingText?: string,
): ErrorProps => {
  let message: string | undefined;
  const [firstError] = meta.errors;

  if (typeof firstError === 'string') {
    message = firstError;
  } else if (
    firstError &&
    typeof firstError === 'object' &&
    'message' in firstError
  ) {
    message = firstError.message;
  }

  const hasError = meta.isTouched && !meta.isValid;

  return {
    error: hasError,
    supportingText: hasError ? message : defaultSupportingText,
    supportingIconConfig: hasError
      ? {
          icon: <IconValidationInvalid />,
        }
      : undefined,
  };
};
